module.exports = __webpack_public_path__ + "img/icon-finaice.f021139b.png";